import type { FC, ReactNode } from 'react'

import SegmentLogo from '@segment/matcha/components/SegmentLogo'

import ButtonText from '@segment/matcha/components/ButtonText'

import UtilityNav from '@segment/matcha/recipes/Navigation/MobileNavigation/UtilityNav'
import MobileNavBase, * as MobileNav from '@segment/matcha/recipes/Navigation/MobileNavigation'
import * as Navbar from '@segment/matcha/recipes/Navigation/MobileNavigation/Navbar'

import type { UtilityNavProps } from '@segment/matcha/recipes/Navigation/types'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

interface MobileNavigationProps extends UtilityNavProps {
  buttonText: string
  buttonLink: string
  after?: ReactNode
}

const MobileNavigation: FC<MobileNavigationProps> = ({ announcement, buttonText, buttonLink, after }) => {
  const pageConfig = usePageConfig()
  return (
    <MobileNavBase>
      {announcement && <UtilityNav announcement={announcement} />}

      <MobileNav.Navbar>
        <Navbar.Brand href="/">
          <SegmentLogo alt="Twilio, Inc." />
        </Navbar.Brand>
        <ButtonText size="small" tag="a" href={getAbsoluteUrl(`${buttonLink}`, pageConfig)} variant="mono">
          {buttonText}
        </ButtonText>
      </MobileNav.Navbar>
      {after}
    </MobileNavBase>
  )
}

export default MobileNavigation
